module.exports = __webpack_public_path__ + "img/start_page_god.eca37efa.png";